import { useMemo } from "react";
import { Line } from "react-chartjs-2";

export default function GraficoMultiLine() {

    const labels = useMemo(() => ["04/07", "05/07", "06/07", "07/07", "08/07", "09/07", "10/07"], [])

    const options: any = {
        responsive: true,
        stacked: false,
        plugins: {
            legend: {
                position: 'bottom',
                align: 'center',
                labels: {
                    boxWidth: 20,
                    font: {
                        size: 11,
                    },
                },
            }
        },
        scales: {
            x: {
                type: 'category',
                labels,
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
            }
        },
    };

    const data = {
        labels,
        datasets: [
            {
                label: 'Saldo previsto',
                data: [10, 20, 30, 40, 50, 60, 70],
                borderColor: '#FF8000',
                backgroundColor: '#FF8000',
            },
            {
                label: 'Recebimento',
                data: [300, 200, 300, 400, 500, 600, 700],
                borderColor: '#1B5E20',
                backgroundColor: '#1B5E20',
            },
            {
                label: 'Pagamentos',
                data: [300, 500, 340, 440, 201, 200, 740],
                borderColor: '#BD3737',
                backgroundColor: '#BD3737',
            },
        ],
    };

    return (
        <Line options={options} data={data} />
    )
}